import Folders from './Folders.vue';

export default Folders;
